import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from '@drdropin-tech/theseus';
const IS_TEST = process.env.NODE_ENV === 'test';
const SpinnerWrapper = ({ testId }) => (_jsx("div", { className: "flex justify-center", ...(IS_TEST && testId
        ? {
            'data-testid': testId,
        }
        : {}), children: _jsx(Spinner, { size: "xl" }) }));
export default SpinnerWrapper;
